import {LeaveWithoutSavingWarningUtility} from "../LeaveWithoutSavingWarningUtility";
import {MessageDisplayerUtility} from "../MessageDisplayerUtility";
import {GenericModel} from "./GenericModel";
import {useRenderableDataStore} from "./useRenderableDataStore";

// Engine for a wrapper component for a form, where wrapper is in charge of creating models defined by the form
export function useModelCreateEngine(
    modelCreateApiFunction: Function,
    modelName: string,
    createCallback: Function,
    verbEdOverride?: string,
    verbIngOverride?: string
) {
    const initialState = {loading: false};
    const createEngineDataStore = useRenderableDataStore(initialState)

    function createModel(formModelData: object, disableNavigationBlocker: Function) {
        createEngineDataStore.updateAndRender({loading: true})
        modelCreateApiFunction(formModelData)
            .then((response: GenericModel) => {
                disableNavigationBlocker();
                LeaveWithoutSavingWarningUtility.disableLeaveWithoutSavingWarnings();
                window.setTimeout(function () {
                    MessageDisplayerUtility.success(
                        `Successfully ${verbEdOverride ? verbEdOverride : 'created'} ${modelName}.`
                    );
                    if (createCallback) {
                        createCallback(response.id);
                    }
                }, 0)
            })
            .catch((error: object) => {
                createEngineDataStore.updateAndRender({loading: false})
                console && console.log(error);
                MessageDisplayerUtility.error(
                    `An error occurred while ${verbIngOverride ? verbIngOverride : 'creating'} the ${modelName}.`
                );
            })
    }

    return {
        dataStore: createEngineDataStore,
        createModel: createModel,
    };
}
